import { render, staticRenderFns } from "./ExperimentalNotice.vue?vue&type=template&id=9c6896f8"
import script from "./ExperimentalNotice.vue?vue&type=script&lang=js"
export * from "./ExperimentalNotice.vue?vue&type=script&lang=js"
import style0 from "./ExperimentalNotice.vue?vue&type=style&index=0&id=9c6896f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports